import React, { useState } from 'react';

/**
 * Mostra il dettaglio tecnico di un errore catturato da useKmQuery,
 * senza dover aprire gli strumenti sviluppatore del browser. L'oggetto
 * error è quello lanciato da client.js (KmApiError): status, detail,
 * technicalMessage ("HTTP {status} su {url}"), correlationId.
 *
 * Stesso principio già usato in ResourceSelfAssessmentPanel.jsx e
 * HrSelfAssessmentConsole.jsx, qui condiviso per non ripeterlo in ogni
 * pagina Esperienze/Ricerca/Schede.
 */
export default function ErrorDetails({ error }) {
  const [show, setShow] = useState(false);
  if (!error) return null;

  return (
    <div style={{ marginTop: 8 }}>
      <button
        type="button"
        onClick={() => setShow((v) => !v)}
        className="btn-link"
        style={{ fontSize: 'var(--font-size-xs)' }}
      >
        {show ? '▲ Nascondi dettagli tecnici' : '▼ Mostra dettagli tecnici'}
      </button>
      {show && (
        <div
          style={{
            marginTop: 6,
            padding: 8,
            borderRadius: 6,
            background: 'var(--color-bg)',
            border: '0.5px solid var(--color-border)',
            fontSize: 11,
            fontFamily: 'monospace',
            whiteSpace: 'pre-wrap',
          }}
        >
          Status: {error.status ?? 'n/d'}{'\n'}
          {error.technicalMessage && `Messaggio tecnico: ${error.technicalMessage}\n`}
          {error.detail && `Detail backend: ${error.detail}\n`}
          {error.correlationId && `Correlation id: ${error.correlationId}\n`}
          {!error.technicalMessage && !error.detail && `Errore grezzo: ${String(error.message || error)}\n`}
        </div>
      )}
    </div>
  );
}
